module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0028.jpg?v=60264bf4";